module.exports = require('./fetch-client.js');